<template>
    <div class="default-entry">
        {{ entry.title }}
    </div>
</template>

<script>
export default {
    name: 'DefaultEntry',
    props: {
        entry: {
          type: Object,
          required: true,
        }
    },
};
</script>